import {Skeleton} from '@/shared/ui/components/skeleton';

export const WorkoutsSkeleton = () => (
  <div className="mx-auto flex w-full max-w-2xl flex-col gap-6 px-4 pt-6 pb-8 sm:px-6 sm:pt-8" aria-busy="true">
    <Skeleton className="h-8 w-48" />
    <Skeleton className="h-4 w-72" />
    <Skeleton className="h-24 w-full" />
    <Skeleton className="h-28 w-full" />
    <Skeleton className="h-28 w-full" />
  </div>
);
